import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import LabServiceForm from '@app/components/apps/LabItemConfig/LabServiceForm';

export const EditLabService: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Lab Service');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/lab-services',
      breadcrumbName: 'All Lab Items',
    },
    {
      path: '/edit-lab-service',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <LabServiceForm
            type={'edit'}
            editable={true}
            id={id}
            pageTitle={`Edit Lab Service`}
            setCurrentBreadcrumName={setCurrentBreadcrumName}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditLabService;
